import { Label, Stack } from "@fluentui/react";
import React from "react";
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";

import { Text } from "../../items/Text";
import { Theme } from "../../theme/Theme";

interface DragAndDropProps {
    label?: string;
    items: DragAndDropItem[];
    onDrop(reorderedItems: DragAndDropItem[]): void;
}

export interface DragAndDropItem {
    key: string;
    text: string;
}

export const DragAndDrop: React.FC<DragAndDropProps> = (props: DragAndDropProps) => {
    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        } else {
            const reorderedList = reorder(props.items, result.source.index, result.destination.index);

            props.onDrop(reorderedList);
        }
    };

    const reorder = (list: DragAndDropItem[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    return (
        <>
            <Label>{props.label}</Label>
            <Stack styles={{ root: { border: "black solid 1px", paddingTop: 3 } }}>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(droppableProvided) => (
                            <div {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
                                {props.items.map((item, index) => (
                                    <Draggable key={item.key} draggableId={item.key} index={index}>
                                        {(draggableProvided) => (
                                            <div
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                                {...draggableProvided.dragHandleProps}
                                                style={{
                                                    margin: "0px 3px 5px 3px",
                                                    padding: 5,
                                                    backgroundColor: Theme.palette.white,
                                                    boxShadow: Theme.effects.elevation8,
                                                    ...draggableProvided.draggableProps.style
                                                }}
                                            >
                                                <Text value={item.text} />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </Stack>
        </>
    );
};
